import React, { Component } from 'react'
import { observer } from 'mobx-react'
import RadioButtonsWrapper from './RadioButtonsWrapper'
import './styles.scss'
import '../../styles/index.scss'

class RadioButtonGroup extends Component {
  onChange = (name, value) => {
    this.props.Store.updateFieldValue(name, value)
    this.props.Store.updateFieldError(name, false)
  }

  render () {
    const { name, options, wrapperClass, automationName, Store } = this.props
    return (
      <RadioButtonsWrapper>
        {
          options.map(opt => {
            const isChecked = Store.getValue(name) === opt.value
            return (
              <div data-automation-name={automationName} value={opt.value} key={`key_${name}_${opt.title}`} className={`radio-inline ${wrapperClass} ${Store.hasError(name) ? 'has-error' : ''}`}>
                <div
                  className={`checkOne ${isChecked ? 'checked' : ''}`}
                  onClick={() => { this.onChange(name, opt.value) }}
                >
                  <label className='radioLabel' data-automation-name={`${opt.value}_${name}`}>
                    <input
                      type='radio'
                      name={name}
                      checked={isChecked}
                      onChange={() => { this.onChange(name, opt.value) }}
                    />
                    <span>&nbsp;</span>{opt.title}
                  </label>
                </div>
              </div>
            )
          })
        }
      </RadioButtonsWrapper>
    )
  }
}

export default observer(RadioButtonGroup)
